"use client";

import { Navbar as BsNavbar, Nav, Container } from "react-bootstrap";
import Image from "next/image";
import Link from "next/link";
import "bootstrap/dist/css/bootstrap.min.css";

const Navbar = () => {
  return (
    <BsNavbar bg="light" expand="lg" className="shadow-sm">
      <Container>
        {/* Brand/logo on the left */}
        <Link href="/" className="navbar-brand fw-bold d-flex align-items-center">
          <Image
            src="/images/aitoolpilot-logo.png" // Make sure exact filename (case-sensitive)
            alt="AIToolPilot Logo"
            width={32}
            height={32}
            className="me-2"
            style={{ objectFit: "contain" }}
          />
          AIToolPilot
        </Link>

        {/* Mobile menu button */}
        <BsNavbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Navigation links on the right */}
        <BsNavbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            <Link href="/" className="nav-link">
              Home
            </Link>
            <Link href="/blog" className="nav-link">
              Blog
            </Link>
          </Nav>
        </BsNavbar.Collapse>
      </Container>
    </BsNavbar>
  );
};

export default Navbar;
